module.exports = __webpack_public_path__ + "img/jieshao1.a4a9c713.png";